<template>
<div class=''>
    <b-card>
        <div class=''>
            <b-row>
                <b-col>
                    <b-row>
                        <b-col md='1'>
                            <img class='photo-customer' :src='user.img' alt=''>
                        </b-col>
                        <b-col md='7'>
                            <h3>Cliente: {{user.name}}</h3>
                            <h4>Saldo actual: $ {{format(saldoAux)}}</h4>
                        </b-col>
                        <b-col>
                            <b-form-checkbox v-model="limit_pay" >
                              Establecer limite de gasto diario?
                            </b-form-checkbox>
                            <br>
                            <b-form inline>
                              <label class="sr-only" for="inlineFormInputName2">Name</label>
                              <b-input :disabled='!limit_pay' class="mb-2 mr-sm-2 mb-sm-0" id="inlineFormInputName2" placeholder="limite gasto diario" v-model="limit_pays" />
                              <b-button :disabled='!limit_pay' variant="primary" @click='btnSaveSaldo'>Guardar</b-button>
                            </b-form>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col md='3'>
                    <b-row>
                        <b-col md='12'>
                            <h4 class='title-item bill'>Categorias</h4>
                            <carousel :perPage='3' :paginationEnabled='false'>
                                <slide class='category-item text-center' v-for='item in categories' :key='item.index'>
                                    <div @click='toggleCategories(item)'>
                                        <b-img rounded='circle' v-bind:src='item.image ? item.img : imgCategory' v-bind:alt='item.name' style='height: 85px;'></b-img>
                                        <p>{{ item.name }}</p>
                                    </div>
                                </slide>
                            </carousel>
                        </b-col>
                        <b-col md='12'>
                            <h4 class='title-item'>Sub categorias {{nameCategory}}</h4>
                            <h4 class='text-center' v-show='subcategories.length==0'>Esta categoria no contiene Subcategorias</h4>
                            <carousel :perPage='3' :paginationEnabled='false'>
                                <slide class='category-item' :navigationEnabled="false" v-for='item in subcategories' :key='item.index'>
                                    <div @click='toggleSubCategories(item)'>
                                        <b-img rounded='circle' v-bind:src='item.image ? item.img : imgSubcategory' v-bind:alt='item.name' style='height: 85px;'></b-img>
                                        <p>{{ item.name }}</p>
                                    </div>
                                </slide>
                            </carousel>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md='6'>
                    <b-row>
                        <h4 class='title-item'>Productos</h4>
                        <div class='cart cart-resume ' style="position:relative;height:350px;overflow-y:auto">

                            <h4 class='text-center' v-show='products.length==0'>No existen productos</h4>
                            <div v-for='item in products' :key='item.index'>
                                <div class='product' data-price='4.9' data-quantity='2' @click='add(item)'>
                                    <div class='product-preview'>
                                        <div class='thumbnail'>
                                            <img class='image' v-bind:src='item.image ? item.img : imgProduct' v-bind:alt='item.name' style='height: 100px;' />
                                            </div>
                                            <div class='product-paper'>
                                                <div class='product-name'>{{ item.name.substring(0, 25) }}</div>
                                                <div class='product-price'>$ {{ item.price }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </b-row>
                </b-col>

                <b-col v-show='list.length>0'>
                    <h4 class='title-item'>
                        Productos restringidos
                    </h4>
                    <div>
                        <b-row style="position:relative;height:350px;overflow-y:auto">
                            <b-col v-for='item in lista' :key='item.index' :md='12'>
                                <b-row class='p-resume' align='center'>  
                                    <b-col md='8' align='center'>
                                        <h5 class='text-center'> {{item.name}}</h5>
                                        <p @dblclick='del(item)'> ${{ item.price }} </p>
                                    </b-col>
                                    <b-col md='4'>
                                        <b-button size='lg' variant='danger' @click='del(item)' block>  <i class="fa fa-times"></i> </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </div>
    </b-card>
</div>
</template>

<script>
export default {
  name: "products_locks",
  data() {
    return {
      modalShow: false,
      list: [],
      products: [],
      subcategories: [],
      categories: [],
      changed: false,
      limit_pay: false,
      limit_pays: 0,
      nameCategory: "",
      nameSubCategory: "",
      total: 0,
      imgCategory: "static/img/category_icon.png",
      imgSubcategory: "static/img/sub_category.png",
      imgProduct: "https://s.cdpn.io/24822/sidebar-cupcake.png",
      user: Object,
      saldoAux: Number
    };
  },
  computed: {
    lista: {
      get: function() {
        return this.list;
      },
      set: function(newVal) {
        //this.calculate();
        this.list = newVal;
      }
    }
  },
  watch: {
    categories: function(newVal) {
      console.log("asada");
    }
  },
  mounted() {
    this.getDataUser();
  },
  created() {
    // this.getCategories()
  },
  methods: {
    setMainPathImage(element) {
      let mainPath = localStorage.getItem("urlApi");
      mainPath = mainPath.replace("/api", "");
      let img = mainPath + element.url;
      return img;
    },
    getDataUser() {
      this.$store
        .dispatch("academicBlockProductsShow", this.$route.params)
        .then(response => {
          this.user = this.$store.getters.academicBlockProducts;
          this.user.img = this.setMainPathImage(this.user);
          this.saldoAux = this.user.saldo;
          this.getProductsLocked();
        })
        .catch(error => {
          console.log("ERROR ", error);
        });
    },
    getProductsLocked() {
      this.$store
        .dispatch("academicBlockProductsList", this.user)
        .then(response => {
          this.list = this.$store.getters.academicBlockProducts;
          if(this.list.length>0){
            this.limit_pay = (this.list[0].saldo > 0)
            this.limit_pays = this.list[0].saldo
          }else{
            this.limit_pay = false
            this.limit_pays = 0
          }
          
          this.getCategories();
        })
        .catch(error => {
          console.log("ERROR ", error);
        });
    },
    getCategories() {
      this.$store
        .dispatch("inventoryProductsCategoriesAll")
        .then(response => {
          this.categories = this.$store.getters.inventoryProductsCategories.items;
          this.categories.forEach(element => {
            let mainPath = localStorage.getItem("urlApi");
            mainPath = mainPath.replace("/api", "");
            element.img = mainPath + element.url;
          });
        })
        .catch(error => {
          console.log("ERROR ", error);
        });
    },
    toggleCategories: function(item) {
      this.nameCategory = "de " + item.name;
      this.$store
        .dispatch("inventoryProductsSubcategoriesAll", item)
        .then(response => {
          this.subcategories = this.$store.getters.inventoryProductsSubCategories;
          this.subcategories.forEach(element => {
            let mainPath = localStorage.getItem("urlApi");
            mainPath = mainPath.replace("/api", "");
            element.img = mainPath + element.url;
          });
          this.products = [];
        })
        .catch(error => {
          console.log("ERROR ", error);
        });
    },
    toggleSubCategories: function(item) {
      let data = {
        id: item.id,
        id_user: this.user.id_user_primary
      };
      this.$store
        .dispatch("inventoryProductsFilterSubCategoriesAll", data)
        .then(response => {
          this.products = this.$store.getters.inventoryProductsSubCategories;
          this.products.forEach(element => {
            let mainPath = localStorage.getItem("urlApi");
            mainPath = mainPath.replace("/api", "");
            element.img = mainPath + element.url;
          });
        })
        .catch(error => {
          console.log("ERROR ", error);
        });
    },
    add(item) {
      this.changed = false;
      this.list.forEach(element => {
        if (element.id === item.id) {
          this.changed = true;
        }
      });
      if (!this.changed) {
        item.count = 1;
        this.list.push(item);
        this.products.splice(this.products.indexOf(item), 1);
      }
      this.lista = this.list;
      this.save();
    },
    del(item) {
      if (this.limit_pay) {
        if (this.limit_pays < 1000) {
          this.$root.showInfoDialog(
            "Mensaje informativo",
            "El menor monto a bloquear es $1.000",
            "Aceptar"
          );
          return;
        }
      }
      this.list.splice(this.list.indexOf(item), 1);
      this.products.push(item);
      this.lista = this.list;
      this.save();
    },
    btnSaveSaldo(){
      if (this.limit_pays < 1000) {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "El menor monto a bloquear es $1.000",
          "Aceptar"
        );
        return;
      }
      this.save()
    },
    save() {
      let data;
      let products = [];
      this.list.forEach(element => {
        products.push(element.id);
      });
      if(this.limit_pay) {
        data = {
          products: JSON.stringify(products),
          id_user: this.user.id_user_primary,
          saldo: this.limit_pays
        };
      } else {
        data = {
          products: JSON.stringify(products),
          id_user: this.user.id_user_primary,
          saldo: 0
        };
      }

      let json = JSON.stringify(data);
      this.$store
        .dispatch("academicBlockProductsStore", json)
        .then(response => {
          console.log("aaa");
        })
        .catch(error => {
          console.log("ERROR ", error);
        });
      // cafeteriaRequestsCreate
    },
    format(value) {
      let conv = (value / 1000).toFixed(3);
      if (conv > 1) {
        return conv;
      }
      return value;
    }
  }
};
</script>

<style>
.p-resume {
  margin: 7px 0;
  padding: 5px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/academic/block_products/products.vue